import * as msg from 'console-tags.js/src/console-tags.js'
import regular from 'shido.regular.js/src/regular.js'

const init = () => {
  msg.success('BlogController', 'Ready!')
  new regular().init();
}

export default init
